export enum EPlotCommand
{
    AddEntity = 1,
    SetAxis,
}